import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import ATag from './ATag';
import ButtonTag from './ButtonTag';
import { TYPES } from './constants';

export { TYPES };

const Button = class extends PureComponent {
  static propTypes = {
    type: PropTypes.oneOf(Object.values(TYPES)),
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onClick: PropTypes.func,
    linkTo: PropTypes.string,
    isFullWidth: PropTypes.bool,
    isSmall: PropTypes.bool,
    isUppercase: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isSubmit: PropTypes.bool,
  };

  static defaultProps = {
    onClick: () => {},
    children: null,
    className: null,
    type: TYPES.DEFAULT,
    linkTo: null,
    isFullWidth: false,
    isSmall: false,
    isUppercase: false,
    isDisabled: false,
    isSubmit: false,
  };

  render() {
    const {
      type,
      className,
      children,
      isFullWidth,
      isSmall,
      isUppercase,
      linkTo,
      isDisabled,
      onClick,
      isSubmit,
      ...otherProps
    } = this.props;

    const classes = classNames('Button', `Button--${type}`, className, {
      'Button--full-width': isFullWidth,
      'Button--small': isSmall,
      'Button--uppercase': isUppercase,
      'Button--disabled': isDisabled,
    });

    return linkTo ? (
      <ATag href={linkTo} className={classes} onClick={onClick} {...otherProps}>
        {children}
      </ATag>
    ) : (
      <ButtonTag
        onClick={onClick}
        className={classes}
        disabled={isDisabled}
        isSubmit={isSubmit}
        {...otherProps}
      >
        {children}
      </ButtonTag>
    );
  }
};

export default Button;
